// extracted by mini-css-extract-plugin
export default {"image":"GY-z","loaded":"HY-z"};